<template>
  <DatePicker
    class="zx-date"
    :class="{ 'zx-date--block': block }"
    :type="pickerType"
    :value="value"
    :format="resolvedFormat"
    :placeholder="placeholder"
    :disabled="disabled || readonly"
    :clearable="clearable"
    :style="wrapStyle"
    @input="onInput"
  />
</template>

<script>
/**
 * 统一日期/时间选择（HeyUI DatePicker）。
 * v-model 字符串与历史 native input 对齐，避免改查询/提交：
 * - date  → YYYY-MM-DD
 * - month → YYYY-MM
 * - datetime / datetime-local → YYYY-MM-DDTHH:mm
 */
const FORMAT = {
	date: 'YYYY-MM-DD',
	month: 'YYYY-MM',
	year: 'YYYY',
	datetime: 'YYYY-MM-DDTHH:mm',
	'datetime-local': 'YYYY-MM-DDTHH:mm'
};

export default {
	name: 'ZxDate',
	props: {
		value: { type: [String, Number, Date], default: '' },
		/** date | month | year | datetime | datetime-local */
		type: { type: String, default: 'date' },
		format: { type: String, default: '' },
		placeholder: { type: String, default: '请选择日期' },
		disabled: { type: Boolean, default: false },
		readonly: { type: Boolean, default: false },
		clearable: { type: Boolean, default: true },
		width: { type: [String, Number], default: null },
		block: { type: Boolean, default: false }
	},
	computed: {
		pickerType() {
			const t = (this.type || 'date').toLowerCase();
			if (t === 'datetime-local' || t === 'datetime') return 'datetime';
			if (t === 'month' || t === 'year' || t === 'date') return t;
			return 'date';
		},
		resolvedFormat() {
			if (this.format) return this.format;
			const t = (this.type || 'date').toLowerCase();
			return FORMAT[t] || FORMAT.date;
		},
		wrapStyle() {
			if (this.block) return { width: '100%' };
			if (this.width == null || this.width === '') return null;
			const w = typeof this.width === 'number' ? this.width + 'px' : this.width;
			return { width: w };
		}
	},
	methods: {
		onInput(v) {
			// HeyUI 可能回 Date；统一成 format 字符串，保证接口仍收 ISO 数字串
			let out = v;
			if (v instanceof Date && !isNaN(v.getTime())) {
				const pad = n => String(n).padStart(2, '0');
				const y = v.getFullYear();
				const m = pad(v.getMonth() + 1);
				const d = pad(v.getDate());
				const hh = pad(v.getHours());
				const mm = pad(v.getMinutes());
				const f = this.resolvedFormat;
				if (f === 'YYYY-MM') out = `${y}-${m}`;
				else if (f === 'YYYY') out = String(y);
				else if (f.indexOf('HH') >= 0) {
					const sep = f.indexOf('T') >= 0 ? 'T' : ' ';
					out = `${y}-${m}-${d}${sep}${hh}:${mm}`;
				} else out = `${y}-${m}-${d}`;
			} else if (out == null) {
				out = '';
			} else {
				out = String(out);
			}
			this.$emit('input', out);
			this.$emit('change', out);
		}
	}
};
</script>

<style lang="less">
/* 与 OA .input 行高/边框大致对齐；不 scoped 以便盖住 HeyUI 内部 */
.zx-date {
	display: inline-block;
	vertical-align: middle;
}
.zx-date.h-date-picker,
.zx-date.h-datetime {
	min-width: 0;
}
.zx-date--block {
	display: block;
	width: 100%;
}
.zx-date--block .h-datetime-show,
.zx-date--block .h-input {
	width: 100%;
}
.form-row .f .zx-date,
.drawer .f .zx-date {
	width: 100%;
}
.form-row .f .zx-date .h-datetime-show,
.drawer .f .zx-date .h-datetime-show,
.form-row .f .zx-date .h-input,
.drawer .f .zx-date .h-input {
	width: 100%;
}
</style>
